import _find from 'lodash/find';

export const optionValue = (item) =>
  typeof item === 'object' && item !== null && 'value' in item ? item.value : item;

export const optionLabel = (item) => {
  if (typeof item === 'object' && item !== null && 'label' in item) return item.label;
  const v = String(item);
  return v.replace(/_/g, ' ');
};

/** Normalize object or array filter options to a list for mapping. */
export const filterOptionsList = (data) => (Array.isArray(data) ? data : Object.values(data ?? {}));

/** Label for a selected value, matching option objects when present. */
export const labelForSelectedFilterValue = (data, value) => {
  const list = filterOptionsList(data);
  const found = _find(list, (d) => optionValue(d) === value);
  return found != null ? optionLabel(found) : optionLabel(value);
};
